import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RESET } from "../types";
import { getShippingRoutes } from "../../api/shipping";
import { dispatchSnackBarMessage } from "../../utils/snackbar";

const initialState = {
  shippingRoutes: [],
  shippingRoute: undefined,
  showShippingRouteModal: false,
  showOrdersListModal: false,
  orderIdToAdd: undefined,
  routeIdToAdd: undefined,
  showAddOrderToRouteModal: false,
  shippingRouteShowId: false,
  showShippingRouteShowModal: false,
};

export const fetchShippingRoutes = createAsyncThunk(
  "shippingRoutes/fetchShippingRoutes",
  async ({ query = undefined }, thunkAPI) => {
    try {
      const params = {
        status: 1,
        query, // Pass the query param here
      };
      const {
        data: { routes },
      } = await getShippingRoutes(params);
      return routes;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
const shippingRoutesSlice = createSlice({
  name: "shippingRoutes",
  initialState,
  reducers: {
    setRouteIdToAdd: (state, action) => {
      state.routeIdToAdd = action.payload;
    },
    setShowShippingRouteModal: (state, action) => {
      state.showShippingRouteModal = action.payload.show;
      state.shippingRoute = action.payload.shippingRoute;
    },
    setShowShippingRouteShowModal: (state, action) => {
      state.shippingRouteShowId = action.payload.id;
      state.showShippingRouteShowModal = action.payload.show;
    },
    setShowOrdersListModal: (state, action) => {
      state.showOrdersListModal = action.payload;
    },
    updateShippingRoutes: (state, action) => {
      if (action.payload.new_status === 3) {
        state.shippingRoutes = state.shippingRoutes.filter(
          (route) => route.id !== action.payload.shipping_route_id
        );
      } else {
        const route = state.shippingRoutes.find(
          (route) => route.id === action.payload.shipping_route_id
        );
        if (route) {
          route.status = action.payload.new_status;
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchShippingRoutes.fulfilled, (state, action) => {
        state.shippingRoutes = action.payload;
        state.loading = false;
      })
      .addCase(fetchShippingRoutes.rejected, (state, action) => {
        dispatchSnackBarMessage(
          `shipping-route-fetch-${new Date()}`,
          "Erro ao carregar entregas em andamento",
          "error"
        );
      })
      .addCase(RESET, () => initialState);
  },
});

export const {
  updateShippingRoutes,
  setRouteIdToAdd,
  setShowShippingRouteModal,
  setShowShippingRouteShowModal,
  setShowOrdersListModal,
} = shippingRoutesSlice.actions;
export default shippingRoutesSlice.reducer;
